import Wrapper from 'base/ui/components/Wrapper';
import React, { useState } from 'react';
import { AiOutlineMinus } from 'react-icons/ai';
import { FaSearch } from 'react-icons/fa';

export type SearchCollapseProps = {
  title?: React.ReactNode;
  children?: React.ReactNode;
  extra?: React.ReactNode;
};

export default function SearchCollapse(props: SearchCollapseProps) {
  const { title, children, extra } = props;
  // mở from search
  const [openSearchBox, setOpenSearchBox] = useState(false);
  return (
    <>
      <div className={`p-2 relative`}>
        <h2 className="text-md font-bold text-gray-800 mb-2 uppercase text-center">{title}</h2>
        {extra && <div className='absolute right-10 top-1/2 -translate-y-1/2'>
          {extra}
        </div>}
        <button
          onClick={() => setOpenSearchBox(!openSearchBox)}
          className="absolute bg-primary cursor-pointer w-7 h-7 rounded-sm top-1/2 -translate-y-1/2 right-0 hover:bg-[#1677FF]/80"
        >
          <div className="relative w-full h-full flex justify-center items-center overflow-hidden">
            <AiOutlineMinus
              className={`absolute text-white ${openSearchBox ? 'translate-x-0 scale-100' : 'translate-x-[200%] scale-0'
                } duration-500 text-default`}
            />
            <FaSearch
              className={` absolute text-white ${openSearchBox ? '-translate-x-[200%] scale-0' : 'translate-x-0 scale-100'
                } duration-500 text-default`}
            />
          </div>
        </button>
      </div>
      <Wrapper
        className={`${openSearchBox ? 'max-h-[200vh]' : 'max-h-0 border-0 py-0'
          } overflow-hidden duration-500 ease-in-out`}
      >
        {children}
      </Wrapper>
    </>
  );
}
